import React from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';

import classes from './MFormPage.module.scss';
import { FormDisplay } from './MFormPage.model';

type Props = {
  className?: string;
  classNameChildrenContent?: string;
  header?: JSX.Element;
  formJSX: JSX.Element | null;
  open?: FormDisplay | null;
  isFullScreen?: boolean;
  classNameEnterDone?: string;
  wideOpen?: boolean;
  onFormOpenStart: () => void;
  onFormCloseEnd: () => void;
  onFormOpenEnd?: () => void;
};
const MFormPageView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classNames(classes['container'], props.className)}>
      <div className={classes['bluer']}></div>
      <div className={classes['header']}>{props.header}</div>
      <div className={classNames(classes['content'], props.classNameChildrenContent)}>{props.children}</div>
      <CSSTransition
        in={props.open === FormDisplay.Side}
        timeout={400}
        classNames={{
          enterActive: classes['form--open'],
          enterDone: classNames(
            props.open && props.isFullScreen
              ? classes['form--fullScreen']
              : props.open && props.wideOpen
                ? classes['form--wideOpen']
                : props.open
                  ? classes['form--open']
                  : '',
            props.classNameEnterDone,
          ),
        }}
        onEntered={props.onFormOpenEnd}
        onEnter={props.onFormOpenStart}
        onExited={props.onFormCloseEnd}
      >
        <div
          className={classNames(classes['form'], {
            [classes['form--fullScreen']]: props.open && props.isFullScreen,
            [classes['form--open']]: props.open && !props.isFullScreen && !props.wideOpen,
            [classes['form--wideOpen']]: props.open && !props.isFullScreen && props.wideOpen,
            ['MFormPage__formIsOpened']: !!props.open, // Keep for using in MServerTable.module.scss (.actionsBar class)
          })}
        >
          {props.formJSX}
        </div>
      </CSSTransition>
    </div>
  );
};

MFormPageView.displayName = 'MFormPageView';
MFormPageView.defaultProps = {};

export default MFormPageView;
